<template>
    <div>
        <v-text-field v-model="url" filled label="URL vers le contenu" />
        <v-layout>
            <v-flex xs4>
                <v-text-field v-model="coordinateX" type="number" filled mask="###"
                              label="Position X en %" />
            </v-flex>
            <v-flex xs4>
                <v-text-field v-model="coordinateY" type="number" filled mask="###"
                              label="Position Y en %" />
            </v-flex>
            <v-flex xs4>
                <v-text-field v-model="coordinateZ" type="number" filled mask="###"
                              label="Position Z en %" />
            </v-flex>
        </v-layout>
        <v-text-field v-model="scale" type="number" filled mask="###" label="Scale en %" />
        <v-layout>
            <v-flex xs4>
                <v-text-field v-model="rotationX" type="number" filled mask="###"
                              label="Rotation X en °" />
            </v-flex>
            <v-flex xs4>
                <v-text-field v-model="rotationY" type="number" filled mask="###"
                              label="Rotation Y en °" />
            </v-flex>
            <v-flex xs4>
                <v-text-field v-model="rotationZ" type="number" filled mask="###"
                              label="Rotation Z en °" />
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs6>
                <v-text-field v-model="sizeL" type="number" filled mask="####"
                              label="Largeur du contenu en pixel" />
            </v-flex>
            <v-flex xs6>
                <v-text-field v-model="sizeH" type="number" filled mask="####"
                              label="Hauteur du contenu en pixel" />
            </v-flex>
        </v-layout>
        <div class="custom_text_delete_item" @click="raDomDeleteContent">
            Supprimer ce composant
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'RaDomItem',
        props: {
            index: {
                type: Number,
                default: null
            }
        },
        computed: {
            url: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].url;
                },
                set (url) {
                    this.$store.commit('actions/raDom/SET_DATA', {
                        url,
                        index: this.index
                    });
                }
            },
            coordinateX: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].coordinate[0];
                },
                set (coordinateX) {
                    this.$store.commit('actions/raDom/SET_DATA_COORDINATE', {
                        indexData: 0,
                        value: coordinateX,
                        index: this.index
                    });
                }
            },
            coordinateY: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].coordinate[1];
                },
                set (coordinateY) {
                    this.$store.commit('actions/raDom/SET_DATA_COORDINATE', {
                        indexData: 1,
                        value: coordinateY,
                        index: this.index
                    });
                }
            },
            coordinateZ: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].coordinate[2];
                },
                set (coordinateZ) {
                    this.$store.commit('actions/raDom/SET_DATA_COORDINATE', {
                        indexData: 2,
                        value: coordinateZ,
                        index: this.index
                    });
                }
            },
            scale: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].scale;
                },
                set (scale) {
                    this.$store.commit('actions/raDom/SET_DATA', {
                        scale,
                        index: this.index
                    });
                }
            },
            rotationX: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].rotation[0];
                },
                set (rotationX) {
                    this.$store.commit('actions/raDom/SET_DATA_ROTATION', {
                        indexData: 0,
                        value: rotationX,
                        index: this.index
                    });
                }
            },
            rotationY: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].rotation[1];
                },
                set (rotationY) {
                    this.$store.commit('actions/raDom/SET_DATA_ROTATION', {
                        indexData: 1,
                        value: rotationY,
                        index: this.index
                    });
                }
            },
            rotationZ: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].rotation[2];
                },
                set (rotationZ) {
                    this.$store.commit('actions/raDom/SET_DATA_ROTATION', {
                        indexData: 2,
                        value: rotationZ,
                        index: this.index
                    });
                }
            },
            sizeL: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].size[0];
                },
                set (sizeL) {
                    this.$store.commit('actions/raDom/SET_DATA_SIZE', {
                        indexData: 0,
                        value: sizeL,
                        index: this.index
                    });
                }
            },
            sizeH: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.contents[this.index].size[1];
                },
                set (sizeH) {
                    this.$store.commit('actions/raDom/SET_DATA_SIZE', {
                        indexData: 1,
                        value: sizeH,
                        index: this.index
                    });
                }
            }
        },
        methods: {
            ...mapActions('actions/raDom', ['raDomTryDeleteComponent']),
            raDomDeleteContent: function () {
                this.raDomTryDeleteComponent(this.index);
            }
        }
    };
</script>

<style scoped>
    .custom_text_delete_item {
        font-size: 12px;
        color: red;
        text-align: center;
        font-style: italic;
        padding-bottom: 5px;
        cursor: pointer;
        margin: 10px 0 0;
    }
</style>
